/**
 * src/lib/constants/procurement.js — Procurement, BOM & material request status enums
 *
 * Single source of truth for purchase-order lifecycle statuses,
 * BOM statuses, and material-request statuses. Import these instead
 * of hardcoding arrays in view/component files.
 */

// Purchase-order lifecycle (active flow)
export const PO_STATUSES = [
  'draft',
  'pending_approval',
  'approved',
  'sent',
  'confirmed',
  'partially_received',
  'received',
];

// Terminal PO statuses (no further action)
export const PO_TERMINAL_STATUSES = ['complete', 'cancelled'];

// Convenience alias used by ProcurementView tab filtering
export const PO_ACTIVE_STATUSES = PO_STATUSES;

// Bill of Materials lifecycle
export const BOM_STATUSES = ['draft', 'confirmed', 'procuring', 'ready'];

// Material request statuses (task-level material tracking)
export const MATERIAL_REQUEST_STATUSES = ['requested', 'ordered', 'confirmed', 'in_transit'];

// Bundle / production stage slugs (legacy 3-column mode)
export const PRODUCTION_STAGE_LABELS = {
  todo: 'To Do',
  wip: 'In Progress',
  done: 'Done',
};

// Deal badge colors keyed by English stage label (bg + text pairs)
export const DEAL_BADGE_COLORS = {
  Lead:        { bg: 'var(--glass)',      color: 'var(--tm)' },
  Contacted:   { bg: 'var(--accent-bg)',  color: 'var(--accent)' },
  Quoted:      { bg: 'var(--warn-tint)',  color: 'var(--warn)' },
  // Categorical "Negotiation" purple — chart_colors exception (no token equivalent).
  // Translucent tint composites on both themes; saturated text reads on light + dark.
  // HEX_TODO[#7c3aed] exception — see color-map.json
  Negotiation: { bg: 'rgba(124,58,237,0.14)', color: '#7c3aed' },
  Won:         { bg: 'var(--sdnb)',       color: 'var(--ok)' },
  Lost:        { bg: 'var(--sprob)',      color: 'var(--spro)' },
};
